module.exports = __webpack_public_path__ + "static/img/2018.4610f548.png";